import React from "react";
import {
  Type,
  useMediaQuery,
  Anchor,
} from "discover.medical.react-component-library";
import {
  AlgorithmCard,
  AlgorithmContent,
  AlgorithmDescription,
  AlgorithmMedia,
  AlgorithmMediaImage,
  AlgorithmPDFText,
} from "./_styled";
import { ALGORITHM_LOGO_PDF_URL } from "../../constants/ui";
import { affordances, logAlgorithmViewed } from "../../util/analytics";

const AlgorithmBlock = ({
  title,
  description,
  mediaType,
  publicId,
  index,
  isMediaClickDisabled,
  handleOpenPDF,
  algorithm,
}) => {
  const mqMinSm = useMediaQuery("min", "sm");
  const mediaName = mediaType === "algorithm" && "Algorithm";
  const pdfLinkName = "[PDF]";
  const splitPublicId = publicId.split("/");
  const splitPublicIdLength = splitPublicId.length;

  const handlePDFLinkClick = (e) => {
    e.preventDefault();
    handleOpenPDF(algorithm.pdfUrl);
    logAlgorithmViewed({
      title,
      mediaId: publicId,
      type: algorithm.format,
      affordance: affordances.INLINE_TOPIC,
    });
  };

  return (
    <AlgorithmCard
      id={splitPublicId?.[splitPublicIdLength - 1]}
      backgroundColor="gray200"
      borderColor="gray400"
      borderStyle="solid"
      borderWidth="1px"
      isRow={mqMinSm}
      isMediaClickDisabled={isMediaClickDisabled}
      data-testid={
        isMediaClickDisabled
          ? "inline-algorithm-media-disabled"
          : "inline-algorithm-media-enabled"
      }
    >
      <AlgorithmMedia
        borderColor="gray400"
        borderStyle="solid"
        borderBottomWidth={!mqMinSm && "1px"}
        data-testid="inline-algorithm-media-card"
      >
        <AlgorithmMediaImage
          alt={title}
          data-testid="inline-algorithm-media-image"
          src={ALGORITHM_LOGO_PDF_URL}
        />
      </AlgorithmMedia>
      <AlgorithmContent>
        <Type
          fontSize="md"
          marginBottom="xs"
          fontWeight="semibold"
          data-testid="inline-algorithm-media-header"
        >
          {index >= 0 && (
            <Type
              noWrap
              element="span"
              fontWeight="normal"
              data-testid="inline-algorithm-media-index"
            >
              {mediaName} {index + 1}: &nbsp;
            </Type>
          )}
          {algorithm?.hasPdf && (
            <Anchor
              kind="anchor"
              data-testid="modal-light-box-pdflink"
              onClick={handlePDFLinkClick}
            >
              {title}
              <AlgorithmPDFText>{pdfLinkName}</AlgorithmPDFText>
            </Anchor>
          )}
        </Type>
        {description && (
          <AlgorithmDescription
            element="p"
            fontSize="sm"
            color="gray800"
            data-testid="inline-algorithm-media-description"
            marginTop="0"
          >
            {description}
          </AlgorithmDescription>
        )}
      </AlgorithmContent>
    </AlgorithmCard>
  );
};

AlgorithmBlock.displayName = "AlgorithmBlock";

export default AlgorithmBlock;
